import axios from 'utils/axios';

export const getAllDigitalUnits = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    sortField = '',
    sorting = '',
    unitCode = '',
    title = '',
    startDate = '',
    endDate = ''
}) => {
    const response = await axios.get(`digital-units`, {
        params: {
            perPage,
            pageNo,
            query,
            sortField,
            sorting,
            unitCode,
            title,
            startDate,
            endDate
        }
    });
    return response.data;
};

